<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div v-if="myData != null && (myData.time > 0 || myData.rank > 0 || showUserDocument)">
        <md-card v-if="myData != null && myData.time > 0" class="rankCard">
          <md-card-content class="md-layout">
            <div
              class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-30"
            >
              <img
                src="https://images.sports4me.at/img/bg/36606389_FHD.jpg"
                title="Urkunde"
              />
            </div>
            <div
              class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-70"
              v-if="finished &&
                myData != null && (myData.rank > 0 || showUserDocument)
              "
            >
              <h3>Glückwunsch, du hast den {{ myData.rank }}. Platz
                <template v-if="myData.time>0">mit einer Zeit von {{ formatTime(myData.time) }} </template>
                erreicht!</h3>
              <p v-if="showUserDocument">
                Deine Urkunde:<br />
                <a
                  v-for="doc in resultDocuments.user"
                  :key="doc._id"
                  target="_blank"
                  :href="getDocumentUrl(doc)"
                  >{{ doc.name }}<br>
                </a>
              </p>
              <p v-if="(resultDocuments.challenge && resultDocuments.challenge.length > 0)">
                Gesamtwertungen:<br />
                <a
                  v-for="doc in resultDocuments.challenge"
                  :key="doc._id"
                  target="_blank"
                  :href="getDocumentUrl(doc)"
                  >{{ doc.name }}<br>
                </a>
              </p>
            </div>
            <div
              class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-70"
              v-else
            >
              <h3>
                Glückwunsch, du hast den Bewerb<br>
                "{{ myData.disciplineName }}"
                <template v-if="myData.time>0">mit einer Zeit von {{ formatTime(myData.time) }} </template>
                beendet!
                <template v-if="myData.rank>0"><br>Derzeit hast du den {{ myData.rank }}. Platz erreicht!</template>
              </h3>
            </div>
          </md-card-content>
        </md-card>
        <md-card v-else class="rankCard">
          <md-card-content class="md-layout">
            <div
              class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-30"
            >
              <img
                src="https://images.sports4me.at/img/bg/28423537_FHD.jpg"
                title="Anmeldung"
              />
            </div>
            <div
              class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-70"
              v-if="
                myData != null && (myData.rank > 0 || showUserDocument)
              "
            >
              <h3>
                Glückwunsch, du hast den Bewerb<br>
                "{{ myData.disciplineName }}"
                <template v-if="myData.time>0">mit einer Zeit von {{ formatTime(myData.time) }} </template>
                beendet!
                <template v-if="myData.rank>0"><br>Derzeit hast du den {{ myData.rank }}. Platz erreicht!</template>
              </h3>
              <p v-if="showUserDocument">
                Deine Urkunde:<br />
                <a
                  v-for="doc in resultDocuments.user"
                  :key="doc._id"
                  target="_blank"
                  :href="getDocumentUrl(doc)"
                  >{{ doc.name }}<br>
                </a>
              </p>
              <p v-if="(resultDocuments.challenge && resultDocuments.challenge.length > 0)">
                Gesamtwertungen:<br />
                <a
                  v-for="doc in resultDocuments.challenge"
                  :key="doc._id"
                  target="_blank"
                  :href="getDocumentUrl(doc)"
                  >{{ doc.name }}<br>
                </a>
              </p>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <md-card>
        <md-card-content>
          <md-table
            :value="searchedData.length > 0 ? this.searchedData : this.data"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Pro Seite</label>
                <md-select v-model="paginationPerPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item._id"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
              <md-field>
                <label for="discipline">Bewerb</label>
                <md-select v-model="filterChallenge" name="discipline">
                  <md-option value=""></md-option>
                  <md-option
                    v-for="item in filterChallengeValues.disciplines"
                    :key="item.name"
                    :label="item.display"
                    :value="item.name"
                  >
                    {{ item.display }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Suche"
                  v-model="searchQuery"
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                md-label="Platz"
                md-sort-by="result.rank"
                md-numeric
                >{{ item.result.rank || "-" }}</md-table-cell
              >
              <md-table-cell md-label="Name" md-sort-by="data.nachname">{{
                item.data.name
              }}</md-table-cell>
              <md-table-cell md-label="Jahrgang" md-sort-by="data.jahrgang">{{
                item.data.jahrgang
              }}</md-table-cell>
              <md-table-cell
                md-label="Geschlecht"
                md-sort-by="data.geschlecht"
                >{{
                  item.data.geschlecht === "male"
                    ? "M"
                    : item.data.geschlecht === "female"
                    ? "W"
                    : ""
                }}</md-table-cell
              >
              <md-table-cell md-label="Verein" md-sort-by="data.verein">{{
                item.data.verein
              }}</md-table-cell>
              <md-table-cell md-label="Firma" md-sort-by="data.firma">{{
                item.data.firma
              }}</md-table-cell>
              <md-table-cell md-label="Bewerb" md-sort-by="disciplineName">{{
                item.disciplineName
              }}</md-table-cell>
              <md-table-cell md-label="Zeit" md-sort-by="result.time">{{
                formatTime(item.result.time)
              }}</md-table-cell>
              <md-table-cell md-label="Admin" v-if="isAdmin">
                <md-button
                  class="md-just-icon md-simple md-primary"
                  @click="openAdminPanel(item)"
                >
                  <md-icon>edit</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="md-layout md-alignment-center-space-between">
            <pagination
              class="pagination-no-border pagination-success md-layout-item"
              v-model="currentPage"
              :per-page="paginationPerPage"
              :total="pTotal"
            >
            </pagination>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <md-dialog
      :md-active.sync="showAdminDialog"
      v-if="adminSelectedChallengeRegistration"
    >
      <md-dialog-title>Activity zuweisen</md-dialog-title>

      <md-dialog-content>
        <md-field>
          <label>Distanz in Meter</label>
          <md-input v-model="adminManualActivity.distanceInMeters" type="text">
          </md-input>
        </md-field>
        <md-field>
          <label>Zeit in Sekunden</label>
          <md-input v-model="adminManualActivity.durationInSeconds" type="text">
          </md-input>
        </md-field>
        <md-button class="md-primary" @click="adminAssignValues()">
          Eingabe übernehmen
        </md-button>
        <md-field>
          <label for="discipline">Bewerb</label>
          <md-select
            v-model="adminSelectedChallengeRegistration.discipline"
            name="discipline"
          >
            <md-option
              v-for="item in filterChallengeValues.disciplines"
              :key="item.name"
              :label="item.display"
              :value="item.name"
            >
              {{ item.display }}
            </md-option>
          </md-select>
        </md-field>
        <md-button class="md-primary" @click="adminAssignDiscipline()">
          Bewerb ändern übernehmen
        </md-button>

        <md-table
          :value="
            adminUserActivities.length > 0 ? this.adminUserActivities : []
          "
          class="table-striped table-hover"
          style="width: 800px"
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Aktivität">
              <i :class="formatActitivityIcon(item.activityType)"></i>
              {{ item.title }}
            </md-table-cell>
            <md-table-cell md-label="Start">{{
              new Date(item.start).toLocaleString()
            }}</md-table-cell>
            <md-table-cell md-label="Distanz">{{
              item.data.distanceInMeters
            }}</md-table-cell>
            <md-table-cell md-label="Zeit">{{
              formatTime(item.durationInSeconds)
            }}</md-table-cell>
            <md-table-cell md-label="zuweisen">
              <md-button
                class="md-just-icon md-simple md-primary"
                @click="adminAssignActivity(item)"
              >
                <md-icon>add_task</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showAdminDialog = false">
          Schließen
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Pagination } from "@/components";
export default {
  components: {
    Pagination
  },
  props: ["challenge", "finished"],
  computed: {
    // chris: I don't think this is used, but leave it here for reference since pagination needs fixing when there is a search query set
    // to() {
    //   let highBound = this.from + this.paginationPerPage;
    //   if (this.pTotal < highBound) {
    //     highBound = this.pTotal;
    //   }
    //   return highBound;
    // },
    // from() {
    //   return this.paginationPerPage * (this.currentPage - 1);
    // },
    // total() {
    //   return this.pTotal;
    // },
    ...mapState({
      isAdmin: state => state.isAdmin || false
    })
  },
  data() {
    return {
      showAdminDialog: false,
      adminSelectedChallengeRegistration: null,
      adminUserActivities: [],
      adminManualActivity: {},
      currentSort: "rank",
      currentSortOrder: "asc",
      paginationPerPage: 5,
      currentPage: 1,
      pPO: [5, 10, 25, 50],
      pTotal: 1,
      pagination: {
        // perPage: 5,
        // currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 1
      },
      searchQuery: "",
      searchedData: [],
      data: [],
      myData: null,
      showUserDocument: false,
      resultDocuments: {},
      filterChallenge: null
    };
  },
  methods: {
    formatTime(value) {
      if (value == null) {
        return null;
      }
      let seconds = value % 60;
      value = Math.floor(value / 60);
      let minutes = value % 60;
      value = Math.floor(value / 60);
      let hours = value;
      let pad = i => ("0" + i).substr(-2);
      return (hours > 0 ? hours + ":" : "") + pad(minutes) + ":" + pad(seconds);
    },
    formatActitivityIcon: activityType => {
      const icons = {
        1: "far fa-running",
        2: "fas fa-walking",
        3: "far fa-biking",
        4: "far fa-swimmer",
        5: "far fa-dumbbell"
      };
      return icons[activityType] ? icons[activityType] : "fas fa-watch-fitness";
    },
    loadData() {
      this.$store
        .dispatch("loadLeaderboard", {
          challengeId: this.challenge._id,
          sort: this.currentSort,
          sortOrder: this.currentSortOrder,
          search: this.searchQuery,
          filter: this.filterChallenge,
          page: this.currentPage,
          pageSize: this.paginationPerPage // pagination.perPage
        })
        .then(res => {
          this.data = res;
          // TODO don't hardcode access to data fields
          res.forEach(item => {
            item.data.name = (
              (item.data.vorname || "") +
              " " +
              (item.data.nachname || "")
            ).trim();
          });
        });
    },
    loadMyData() {
      this.$store
        .dispatch("loadMyLeaderboard", {
          challengeId: this.challenge._id
        })
        .then(res => {
          if(res.result) {
            this.myData = res.result;
            this.myData.disciplineName = res.disciplineName;
          }
        });
    },
    loadChallengeResultsCount() {
      this.$store
        .dispatch("loadChallengeResultsCount", {
          challengeId: this.challenge._id
        })
        .then(res => {
          this.pTotal = res.count || 1;
        });
    },
    loadChallengeResultDocuments() {
      this.$store
        .dispatch("queryAPI", {url: "/rest/challenge/" + this.challenge._id + "/documents", options: { view: "web"}})
        .then(res => {
          this.resultDocuments.user = res.user || res || [];
          this.showUserDocument = (this.resultDocuments.user.length > 0);
          this.resultDocuments.challenge = res.challenge;
        });
    },
    getDocumentUrl(document) {
      if(document.link && document.link.startsWith("http")) {
        return document.link
      }
      return (
        process.env.VUE_APP_BACKEND_URL +
        "/rest/document/" +
        document._id +
        "/data"
      );
    },
    async openAdminPanel(challengeRegistration) {
      this.adminUserActivities = [];
      this.adminSelectedChallengeRegistration = challengeRegistration;
      this.adminUserActivities = await this.$store.dispatch(
        "adminLoadUserActivities",
        {
          userId: challengeRegistration.userId
        }
      );
      this.showAdminDialog = true;
    },
    async adminAssignActivity(activity) {
      let result = window.confirm(
        `Für User "${
          this.adminSelectedChallengeRegistration.data.name
        }" die Distanz ${activity.data.distanceInMeters} m und die Zeit ${
          activity.durationInSeconds
        } s (${this.formatTime(activity.durationInSeconds)}) setzen?`
      );
      if (!result) {
        return;
      }
      await this.$store.dispatch("adminAssignResultActivity", {
        challengeRegistrationId: this.adminSelectedChallengeRegistration._id,
        activityId: activity._id
      });
      this.showAdminDialog = false;
    },
    async adminAssignValues(activity) {
      let result = window.confirm(
        `Für User "${
          this.adminSelectedChallengeRegistration.data.name
        }" die Distanz ${
          this.adminManualActivity.distanceInMeters
        } m und die Zeit ${
          this.adminManualActivity.durationInSeconds
        } s (${this.formatTime(
          this.adminManualActivity.durationInSeconds
        )}) setzen?`
      );
      if (!result) {
        return;
      }
      await this.$store.dispatch("adminAssignResultValues", {
        challengeRegistrationId: this.adminSelectedChallengeRegistration._id,
        duration: this.adminManualActivity.durationInSeconds,
        distance: this.adminManualActivity.distanceInMeters
      });
      this.showAdminDialog = false;
    },
    async adminAssignDiscipline() {
      const discipline = this.adminSelectedChallengeRegistration.discipline;
      const disciplineName = (this.filterChallengeValues.disciplines.filter(o=>o.name==discipline))[0].display;
      if(!disciplineName) {
        alert('disciplineName not found!!!')
        return false;
      }
      let result = window.confirm(
        `Soll der Bewerb für "${
          this.adminSelectedChallengeRegistration.data.name
        }" auf ${
          disciplineName
        } gesetzen werden?`
      );
      if (!result) {
        return;
      }
      await this.$store
          .dispatch("postAPI", {
            url: `/rpc/challenge/Registration/${this.adminSelectedChallengeRegistration.challengeId}/${this.adminSelectedChallengeRegistration.userId}`,
            method: "PATCH",
            data: {
              discipline: discipline,
              disciplineName: disciplineName
            }
          })
          .then(res => {
            this.$emit("closeMe");
            this.$notify({
              timeout: 5000,
              message: "Erfogleicht bearbeitet",
              type: "success"
            });
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              type: "error"
            });
          });
      // await this.$store.dispatch("adminAssignResultValues", {
      //   challengeRegistrationId: this.adminSelectedChallengeRegistration._id,
      //   duration: this.adminManualActivity.durationInSeconds,
      //   distance: this.adminManualActivity.distanceInMeters
      // });
      this.showAdminDialog = false;
    }
  },
  watch: {
    searchQuery(value) {
      this.loadData();
    },
    currentSortOrder() {
      this.loadData();
    },
    currentSort() {
      this.loadData();
    },
    currentPage() {
      this.loadData();
    },
    paginationPerPage(v) {
      this.loadData();
    },
    filterChallenge(v) {
      this.loadData();
    }
  },
  created() {
    this.filterChallengeValues = this.challenge;
  },
  mounted() {
    this.loadData();
    this.loadMyData();
    this.loadChallengeResultsCount();
    this.loadChallengeResultDocuments();
  }
};
</script>

<style lang="css" scoped>
.rankCard h3 {
  margin: 0;
}
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
